import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {CurrentOddsModuleConfig} from "./current-odds-module.config";
import {CurrentOddsModuleStore} from "./current-odds-module.store";
import {CurrentOddsModuleHandlers} from "./handlers/current-odds-module.handlers";

export class CurrentOddsModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, CurrentOddsModuleConfig, CurrentOddsModuleStore, CurrentOddsModuleHandlers];
}
